
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TenteTamiriPage = lazy(() => import('../pages/services/tente-tamiri/page'));
const KorukluTentePage = lazy(() => import('../pages/services/koruklu-tente-tamiri/page'));
const MafsalliTentePage = lazy(() => import('../pages/services/mafsalli-tente-tamiri/page'));
const BrandaDegisimiPage = lazy(() => import('../pages/services/branda-degisimi/page'));
const TenteYenilemePage = lazy(() => import('../pages/services/tente-yenileme/page'));
const ManuelMotorluTentePage = lazy(() => import('../pages/services/manuel-motorlu-tente-servisi/page'));
const BioklimatikPergolaPage = lazy(() => import('../pages/services/bioklimatik-pergola-tente/page'));
const OtomatikPergolaPage = lazy(() => import('../pages/services/otomatik-pergola-tente/page'));
const KasetliTentePage = lazy(() => import('../pages/services/kasetli-tente/page'));
const TModulTentePage = lazy(() => import('../pages/services/t-modul-tente/page'));
const ZipPerdeTentePage = lazy(() => import('../pages/services/zip-perde-tente/page'));
const SeffafStorTentePage = lazy(() => import('../pages/services/seffaf-stor-tente/page'));
const FermuarSeffafTentePage = lazy(() => import('../pages/services/fermuar-seffaf-tente/page'));
const FransizTentePage = lazy(() => import('../pages/services/fransiz-tente/page'));
const KarpuzTentePage = lazy(() => import('../pages/services/karpuz-tente/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CerezPolitikasiPage = lazy(() => import('../pages/cerez-politikasi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />
  },
  {
    path: '/hizmetler/tente-tamiri',
    element: <TenteTamiriPage />
  },
  {
    path: '/hizmetler/koruklu-tente-tamiri',
    element: <KorukluTentePage />
  },
  {
    path: '/hizmetler/mafsalli-tente-tamiri',
    element: <MafsalliTentePage />
  },
  {
    path: '/hizmetler/branda-degisimi',
    element: <BrandaDegisimiPage />
  },
  {
    path: '/hizmetler/tente-yenileme',
    element: <TenteYenilemePage />
  },
  {
    path: '/hizmetler/manuel-motorlu-tente-servisi',
    element: <ManuelMotorluTentePage />
  },
  {
    path: '/hizmetler/bioklimatik-pergola-tente',
    element: <BioklimatikPergolaPage />
  },
  {
    path: '/hizmetler/otomatik-pergola-tente',
    element: <OtomatikPergolaPage />
  },
  {
    path: '/hizmetler/kasetli-tente',
    element: <KasetliTentePage />
  },
  {
    path: '/hizmetler/t-modul-tente',
    element: <TModulTentePage />
  },
  {
    path: '/hizmetler/zip-perde-tente',
    element: <ZipPerdeTentePage />
  },
  {
    path: '/hizmetler/seffaf-stor-tente',
    element: <SeffafStorTentePage />
  },
  {
    path: '/hizmetler/fermuar-seffaf-tente',
    element: <FermuarSeffafTentePage />
  },
  {
    path: '/hizmetler/fransiz-tente',
    element: <FransizTentePage />
  },
  {
    path: '/hizmetler/karpuz-tente',
    element: <KarpuzTentePage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />
  },
  {
    path: '/kvkk',
    element: <KVKKPage />
  },
  {
    path: '/cerez-politikasi',
    element: <CerezPolitikasiPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
